"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.checkConditionalLogic = checkConditionalLogic, exports.parseLogicType = parseLogicType, exports.parseOperator = parseOperator;
function checkConditionalLogic(a) {
  var b = !!(1 < arguments.length && void 0 !== arguments[1]) && arguments[1],
    c = a.rules,
    d = a.actionType,
    e = a.logicType;
  if (!c) return !0;
  var f = [];
  c.forEach(function (a, c) {
    var d = a.fieldId,
      e = a.value,
      g = a.operator,
      h = b[d].value;
    if (h instanceof Array) {
      var i = 0;
      0 < h.length && h.forEach(function (a) {
        parseOperator(a, g, e) && i++;
      }), f[c] = "isnot" == g ? i == e.length : 0 < i;
    } else f[c] = parseOperator(h, g, e);
  });
  var g = parseLogicType(e, f);
  return "show" === d && (g = !g), g;
}
function parseOperator(a, b, c) {
  switch (b) {
    case "is":
      return c === a;
    case "isnot":
      return c != a;
    case "<":
      return a < c;
    case ">":
      return a > c;
    case "contains":
      return 0 <= a.indexOf(c);
    case "starts_with":
      return 0 == a.indexOf(c);
    case "ends_with":
      {
        var d = a.length - c.length;
        if (0 > d) return !1;
        var e = a.substring(d);
        return c == e;
      }
    default:
      return console.error("ERROR: ".concat(b, " is not known. showing field anyway")), !1;
  }
}
function parseLogicType(a, b) {
  return "any" === a ? b.includes(!0) : "all" === a ? b.every(function (a) {
    return !0 === a;
  }) : void 0;
}